import React from 'react';
import PerfectMatchView from './PerfectMatchView';

export interface PerfectMatchRouteProps {
  className?: string;
}

const PerfectMatchRoute: React.FC<PerfectMatchRouteProps> = ({ className = '' }) => {
  return (
    <div className={className}>
      <PerfectMatchView />
    </div>
  );
};

export default PerfectMatchRoute;
